import React from 'react';
import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';
import KudosPage from '../components/KudosPage/lazy';
import RecordTransition from '../components/RecordTransition';
function hasProfileProp(state) {
  return !!state && 'profile' in state;
}
const KudosPageRoute = ({
  match,
  location
}) => {
  const {
    uuid
  } = match.params;
  const profile = hasProfileProp(location.state) ? location.state.profile : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecordTransition, {
    name: AnalyticsKeys.KUDOS_PAGE_VIEW
  }), /*#__PURE__*/React.createElement(TrackPageLoad, {
    name: AnalyticsKeys.KUDOS_PAGE_VIEW
  }), /*#__PURE__*/React.createElement(KudosPage, {
    uuid: uuid,
    referrerProfile: profile
  }));
};
export default KudosPageRoute;